<app-modal-header [text]="title"></app-modal-header>
<ion-content>
  <div #content></div>
</ion-content>
<app-modal-footer [buttons]="buttons"></app-modal-footer>
